import { useLocation } from 'react-router-dom';

export function useEmptyResult(): boolean {
    const location = useLocation();
    return location.state && location.state.noResults !== undefined && location.state.noResults;
}
